module.exports = __webpack_public_path__ + "media/images/kml_feed-0fdd8548b77d37271d46b72cd861aa45.png";